import script from "./SidebarAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarAdmin.vue?vue&type=script&setup=true&lang=js"

import "./SidebarAdmin.vue?vue&type=style&index=0&id=ccb88858&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccb88858"]])

export default __exports__